import angular from 'angular';

export default angular.module('shared').constant('userProvisioningConstants', {
    method: {
        manual: 'Manual',
        jit: 'JIT',
        scim: 'SCIM'
    },
    sso: {
        off: 'Off',
        optional: 'Optional',
        required: 'Required'
    }
});



// WEBPACK FOOTER //
// ./modules/shared/constants/userProvisioning.constant.js